import { render, staticRenderFns } from "./evaluacion-docente.vue?vue&type=template&id=76acf9e9"
import script from "./evaluacion-docente.vue?vue&type=script&lang=js"
export * from "./evaluacion-docente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports